import React from 'react'
import './footer.css'
import images from "../../Resources/images";
import { Link, useNavigate } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaYoutube, FaPinterest } from "react-icons/fa";
export default function Footer() {
    return (
        // footer
        <div className='fixed-footer'>
            <footer className="py-3">
                <div className="container-fluid">
                    <div className="row gy-4" style={{ height: "max-content" }}>
                        {/* Logo & Copyright */}
                        <div className="col-12 col-md-4 text-center text-md-start">
                            <img src={images.logo} alt="Logo" style={{ height: "100px" }} />
                            <p className="mt-3">© 2025 WEDSTRA. All rights reserved.</p>
                        </div>

                        {/* Navigation Links */}
                        <div className="col-6 col-md-2">
                            <h5>Company</h5>
                            <ul className="list-unstyled">
                                <li>
                                    <a
                                        href="/about-us"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="footer-link"
                                    >
                                        About
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="/blogs"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="footer-link"
                                    >
                                        Blog
                                    </a>
                                </li>
                            </ul>
                        </div>


                        <div className="col-6 col-md-2">
                            <h5>Support</h5>
                            <ul className="list-unstyled">
                                <li><a href="#" className="footer-link">FAQs</a></li>
                                <li>
                                    <a
                                        href="/privacy-policy"
                                        className="footer-link"
                                        target="_blank"
                                        rel="noopener noreferrer">Privacy Policy
                                    </a>
                                </li>
                                <li>
                                    <a href="/terms-conditions"
                                        className="footer-link"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        Terms & Conditions
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-6 col-md-2">
                            <h5>Services</h5>
                            <ul className="list-unstyled">
                                <li><a href="/plans" className="footer-link" target="_blank"
                                    rel="noopener noreferrer">Pricing</a></li>
                                <li><a href="#" className="footer-link">Features</a></li>
                                <li><a href="#" className="footer-link">Integration</a></li>
                                <li><a href="#" className="footer-link">Partners</a></li>
                            </ul>
                        </div>

                        {/* Social Media */}
                        <div className="col-12 col-md-2 text-center text-md-end">
                            <h5>Follow Us</h5>
                            <div className="d-flex justify-content-center justify-content-md-end gap-3 mt-2">
                                <a href="#" className="social-icon"><FaFacebook /></a>
                                <a href="#" className="social-icon"><FaInstagram /></a>
                                <a href="#" className="social-icon"><FaYoutube /></a>
                                <a href="#" className="social-icon"><FaPinterest /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
